<p>loading-button works!</p>
